import { useTranslationChange } from 'i18nano'

import type { Language } from 'shared/lib/i18n'
import { updateStorage } from 'shared/lib/storage'

/** The panel's language: it applies at once and is kept on this device for the next visit. */
export function useLanguage() {
	const { lang, change } = useTranslationChange()

	const choose = (next: string) => {
		updateStorage('user-preferences', { language: next as Language })
		change(next)
	}

	return { lang: lang as Language, choose }
}
